import { cva } from 'class-variance-authority';
import clsx from 'clsx';
import * as React from 'react';

const iconStyles = cva('tw-inline-flex', {
    variants: {
        color: {
            default: 'tw-text-primary',
            destructive: 'tw-text-destructive',
            info: 'tw-text-sky-800',
            secondary: 'tw-text-secondary',
            sideMenu: 'tw-text-grey',
            success: 'tw-text-green-600',
            warning: 'tw-text-amber-800'
        },
        size: {
            small: 'tw-text-sm',
            medium: 'tw-text-lg',
            large: 'tw-text-2xl'
        }
    },
    defaultVariants: {
        color: 'default',
        size: 'medium'
    }
});

const IconFa = ({ color, className = '', icon, size, ...props }) => {
    const iconClassName = clsx(iconStyles({ color, size }), className);

    return (
        <div
            className={iconClassName}
            dangerouslySetInnerHTML={{ __html: WiseMetering.icon(icon) }}
            {...props}
        />
    );
};

IconFa.displayName = 'IconFa';

export { IconFa };
